module.exports = __webpack_public_path__ + "static/media/24.4da29a73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/views/24.jpg
// module id = 389
// module chunks = 0